<template>
  <div class="subpage container flex-column-start">
    <Header v-if="$route.query.platform !== 'mini'" title="订单填写" :is-sub-page="true"></Header>
    <cube-scroll class="order" style="flex: 1; overflow:hidden; background-color: #f7f7f7;">
      <router-link :to="{path: '/EditReceiveAddress', query: {platform: $route.query.platform, token: $route.query.token}}" class="addressEmpty" v-if="wholeAddress==false">
        <img src="@/assets/images/icons/icon-add-new.png" class="addImage" />
        <span class="address-font">添加新地址</span>
        <img src="@/assets/images/icons/icon-arrow-right.png" class="skipImage" />
      </router-link>
      <router-link :to="{path: '/EditReceiveAddress', query: {platform: $route.query.platform, token: $route.query.token}}" class="wholeAddress" v-else>
        <img class="addressImg" src="@/assets/images/icons/icon-address.png"/>
        <div class="middle">
          <div class="name-phone">
            <span class="name">{{this.addrInfo.name}}</span>
            <span class="phone">{{this.addrInfo.phone}}</span>
          </div>
          <div class="address">
            {{this.addrInfo.province}}&nbsp;
            <template v-if="addrInfo.province !== this.addrInfo.city">{{this.addrInfo.city}}&nbsp;</template>
            {{this.addrInfo.area}}&nbsp;
            {{this.addrInfo.address}}
          </div>
        </div>
        <img src="@/assets/images/icons/icon-arrow-right.png" class="skipImage" />
      </router-link>
      <div class="product">
        <img v-if="goodsInfo.coverUrl" :src="goodsInfo.coverUrl" class="productImage" />
        <div v-else class="productImage" style="display: flex; align-items: center; justify-content: center;">暂无图片</div>

        <div class="product-name-price" style="flex: 1;">
          <div class="product-name">{{this.goodsInfo.title}}</div>
          <div class="product-price">{{this.goodsInfo.value}}积分</div>
        </div>
        <div class="product-number" style="margin: 0 10px;">x1</div>
      </div>
    </cube-scroll>
    <div class="fixed-button">
      <div class="integral half-safe-padding">
        <span>合计: </span>
        <span>{{this.goodsInfo.value}}积分</span>
      </div>
      <div class="conversion-button half-safe-padding" @click="showClose">立即兑换</div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { queryAddress, queryGoodsDetail, buyGoods } from '@/api/shop'

// const { mapState } = createNamespacedHelpers('@/store/module')
export default {
  name: '',
  data () {
    return {
      wholeAddress: false,
      addrInfo: {
        address: '',
        name: '',
        phone: '',
        city: '',
        province: '',
        area: ''
      },
      goodsInfo: {
        title: '',
        coverUrl: '',
        value: '',
        content: ''
      }
    }
  },
  computed: {
    addressInfo: function () {
      let data = this.$store.state.userInfo.addressInfo
      if (data.selectedText !== '点击选择') {
        var address = data.selectedText.split(' ').join('')
        data.detailAddress = address + data.textarea
      }
      return data
    }
  },
  mounted () {
    document.title = '订单填写'
    console.log('Order  goods  id=' + this.$route.params.id)
    this.getData()
    this.getAddress()
  },
  methods: {
    showClose () {
      this.$createDialog({
        type: 'confirm',
        title: '确认兑换?',
        content: '将扣除' + this.goodsInfo.value + '积分',
        confirmBtn: {
          text: '确定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          // 兑换
          buyGoods({
            goodsId: parseInt(this.$route.params.id)
          }).then((res) => {
            this.$createDialog({
              type: 'alert',
              icon: 'cubeic-smile',
              title: '兑换成功',
              onConfirm: () => {
                this.$router.go(-1)
              }
            }).show()
          })
        },
        onCancel: () => {
        }
      }).show()
    },
    getAddress () {
      queryAddress({}).then((res) => {
        this.addrInfo.address = res.data.address
        this.addrInfo.city = res.data.city
        this.addrInfo.province = res.data.province
        this.addrInfo.area = res.data.area
        this.addrInfo.name = res.data.name
        this.addrInfo.phone = res.data.phone

        if (this.addrInfo.address.length !== 0 && this.addrInfo.city.length !== 0 &&
            this.addrInfo.province.length !== 0 && this.addrInfo.area.length !== 0 && this.addrInfo.name.length !== 0 &&
            this.addrInfo.phone.length !== 0) {
          this.wholeAddress = true
        }
      })
    },
    getData () {
      console.log('goodsId=' + parseInt(this.$route.params.id))
      queryGoodsDetail({
        goodsId: parseInt(this.$route.params.id)
      }).then((res) => {
        this.goodsInfo.title = res.data.name
        this.goodsInfo.coverUrl = res.data.cover.resUrl
        this.goodsInfo.value = res.data.value
        this.goodsInfo.content = res.data.detail
      })
    }
  },
  components: {
    Header
  }
}
</script>

<style lang="stylus" scoped>
  .my-content
    height 100px
  .my-title
    height 100px
  .my-title-img
    height: 120px;
    margin-bottom: 16px;
    background: url('~@/assets/images/icons/icon-back.png') no-repeat 50%;
    background-size: 100%;
  .addressEmpty
    width: 100%;
    height: 49px;
    background-color: #FFFFFF;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    .addImage
      height: 25px;
      width: 25px;
      margin-left: 20px;
    .address-font
      margin-left: 12px;
      font-size: 14px;
      color: #363636;
    .skipImage
      width: 14px;
      height: 23px;
      margin-left: 203px;
  .wholeAddress
    width: 100%
    padding 20px 0
    background-color: #FFFFFF
    margin-top: 5px
    display: flex
    justify-content: flex-start
    align-items center
    .addressImg
      height 35px
      width 35px
      margin-left 20px
    .skipImage
      width: 14px
      height: 23px
      margin-left 13px
    .middle
      margin-left 16px
      font-size 15px
      line-height 22px
      color #363636
      font-family PingFangSC-Regular,PingFangSC;
      font-weight 400
      .name-phone
        text-align left
        .phone
          margin-left 20px
      .address
        text-align left
        width 257px
        height 42px
        margin-top 10px

  .product
    width: 100%;
    height: 109px;
    background-color: #FFFFFF;
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .productImage
      border: 1px solid #DDDDDD;
      width: 105px;
      height: 94px;
      margin-left: 15px;
      object-fit cover
    .product-name-price
      margin-left: 15px;
      height: 100px;
      display flex
      flex-direction column
      justify-content center
      .product-name
        color: #363636;
        font-size: 15px;
        text-align left
        line-height 22px;
      .product-price
        margin-top: 16px;
        display: flex;
        justify-content: flex-start;
    .product-number
      font-size: 18px;
      color: #363636;
  .fixed-button
    width: 100%;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #545454;
    .conversion-button
      background-color: #662C85;
      height: 45px;
      width: 156px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      font-size: 17px;
    .integral
      margin-left: 20px;
      font-size: 17px;
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
